import { CheckCircleFilled } from '@ant-design/icons';
import { Fragment } from 'react';
import { Tag } from 'antd';

import { Coverage, CoverageException } from './selection';
import * as S from './styled';

interface Props {
  coverage: Coverage;
  /** Jump the recipient tree to a company when its name is clicked. */
  onSelectCompany?: (companyId: string) => void;
}

const CoverageExceptions = ({ coverage, onSelectCompany }: Props) => {
  const { excluded, partial } = coverage;

  if (excluded.length === 0 && partial.length === 0) {
    return (
      <S.AllIncluded align="center" gap={8}>
        <CheckCircleFilled />
        All in-service companies are fully included in this send.
      </S.AllIncluded>
    );
  }

  // Comma-separated clickable company names; each jumps the tree to that company.
  const names = (entries: CoverageException[], label: (c: CoverageException) => string) =>
    entries.map((c, i) => (
      <Fragment key={c.companyId}>
        {i > 0 && ', '}
        <S.CoverageLink type="button" onClick={() => onSelectCompany?.(c.companyId)}>
          {label(c)}
        </S.CoverageLink>
      </Fragment>
    ));

  return (
    <S.Coverage vertical gap={8}>
      {excluded.length > 0 && (
        <S.CoverageRow gap={8} align="baseline">
          <Tag color="error" bordered={false}>
            Won’t receive
          </Tag>
          <S.CoverageNames>{names(excluded, (c) => c.companyName)}</S.CoverageNames>
        </S.CoverageRow>
      )}
      {partial.length > 0 && (
        <S.CoverageRow gap={8} align="baseline">
          <Tag color="warning" bordered={false}>
            Partial
          </Tag>
          <S.CoverageNames>
            {names(partial, (c) => `${c.companyName} (${c.selected}/${c.total})`)}
          </S.CoverageNames>
        </S.CoverageRow>
      )}
    </S.Coverage>
  );
};

export default CoverageExceptions;
